import React from "react";

const styles = {
  wrapper: {
    marginBottom: "28px",
  },
  topRow: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  iconBox: {
    width: "48px",
    height: "48px",
    borderRadius: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 85%), color-mix(in srgb, var(--btn-color), transparent 92%))",
    color: "var(--btn-color)",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
    lineHeight: "1.3",
  },
  subtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
    paddingLeft: "54px",
    lineHeight: "1.4",
  },
};

const PageHeader = ({ icon, title, subtitle, children }) => (
  <div style={styles.wrapper}>
    <div style={styles.topRow}>
      <div style={styles.iconBox}>
        <i className={`mdi ${icon}`} style={{ fontSize: "20px" }}></i>
      </div>
      <h2 style={styles.title}>{title}</h2>
      {children}
    </div>
    {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
  </div>
);

export default PageHeader;
